import React, { useState } from 'react';

import styles from './faqCard.module.css';

const FaqCard = ({ faq }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={styles.faqCard} onClick={() => setIsOpen(!isOpen)}>
      <h4>{faq.question}</h4>
      {isOpen && <p>{faq.answer}</p>}
    </div>
  );
};

export default FaqCard;
